module.exports = __webpack_public_path__ + "static/media/success.ec8fd353.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/success.png
// module id = 802
// module chunks = 0